module.exports = __webpack_public_path__ + "img/search-icon-normal.34986e9e.svg";